import { Pipe, PipeTransform } from '@angular/core';
import { InstallationObservationPluginService } from './observationsandrecommandations-plugin.service';

@Pipe({
    name: 'priorities',
    standalone: false
})
export class ObservationPrioritiesPipe implements PipeTransform {
  public priorities: any;

  constructor(private service: InstallationObservationPluginService) {
    this.priorities = this.service.getPriorities();
  }

  transform(id: string): any {
    return this.service.getValue(id, this.priorities);
  }
}
